<template>
  <div id="pickup-acknowledgement">
    <div class="container">
      <br /><br />
      <h4 class="text-left mb-3">Pickup Acknowledgement</h4>

      <div class="admin-wrap">
        <div class="pb-5">
          <div class="empty-list_image" v-if="SchoolStudentListInt.length < 1">
            <strong>{{ startupText }}</strong>
            <img src="../assets/notfound.png" />
          </div>

          <div v-if="SchoolStudentListInt.length > 0" class="datatable_group">
            <div>
              <el-input class="search-datatable" placeholder="Search Students" v-model="SchoolStudentListFilters[0].value">
                <template slot="prepend">
                  <i class="material-icons">search</i>
                  <span>Search Students(with last 4 digit FIN or student numbers)</span>
                </template>
              </el-input>
            </div>

            <data-tables
              ref="selectableTable"
              :page-size="pageSize"
              :pagination-props="{ pageSizes: [pageSize, 100] }"
              :filters="SchoolStudentListFilters"
              :data="SchoolStudentListInt"
              width="55"
              stripe
              tooltip-effect="light"
              border
            >
              <el-table-column v-for="item in SchoolStudentList" :prop="item.prop" :label="item.label" :key="item.prop" sortable="custom"> </el-table-column>
              <el-table-column>
                <template slot-scope="scope">
                  <el-button-group>
                    <el-button type="primary" icon="el-icon-edit" v-on:click="getAuthorizePickupDetail(scope.row)" circle>More</el-button>
                  </el-button-group>
                </template>
              </el-table-column>
            </data-tables>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="AuthorizedPickupModal"
      size="lg"
      title="Please select authorized pickup person"
      ok-only
      ok-variant="secondary"
      hide-footer
      ref="showAuthorizedPickupModal"
    >
      <div>
        <data-tables :data="authorizedPickupListInt" width="55" stripe tooltip-effect="light" border>
          <!--                    <el-table-column v-for="imageItem in authorizedPickupListInt"-->
          <!--                                     label="Image"-->
          <!--                                     :key="imageItem.ID">-->
          <!--                            <img :src="imageItem.AutPickImage" type="file" height="150px" width="300px"-->
          <!--                                 class="authorizePickupImage" />-->
          <!--                    </el-table-column>-->
          <el-table-column v-for="item in authorizedPickupList" :prop="item.prop" :label="item.label" :key="item.prop"> </el-table-column>
          <el-table-column>
            <template slot-scope="scope">
              <img :src="scope.row.AutPickImage" type="file" height="150px" width="300px" class="authorizePickupImage" />
            </template>
          </el-table-column>
          <el-table-column>
            <template slot-scope="scope">
              <el-button-group v-if="signIn">
                <el-button type="success" icon="el-icon-check" v-on:click="getAuthSignature(scope.row, 'In')" circle>Sign In</el-button>
              </el-button-group>
              <el-button-group v-if="signOut">
                <el-button type="danger" v-on:click="getAuthSignature(scope.row, 'Out')" circle>Sign Out</el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </data-tables>
      </div>
    </b-modal>

    <b-modal id="signaturePadModal" size="lg" title="Please sign here" ok-only ok-variant="secondary" hide-footer ref="showSignaturePadModal">
      <div class="col-12 mt-2">
        <VueSignaturePad
          id="signature"
          width="100%"
          height="500px"
          ref="signaturePad"
          :options="{
            onBegin: () => {
              this.$refs.signaturePad.resizeCanvas()
            },
          }"
        />
        <br />
        <div>
          <el-button @click="save">Save</el-button>
          <el-button @click="undo">Undo</el-button>
          <el-button @click="clear">Clear</el-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import DataSource from '../data/datasource'
import Cookies from 'js-cookie'
import VueSignaturePad from 'vue-signature-pad'
import Vue from 'vue'

Vue.use(VueSignaturePad)
export default {
  name: 'PickupAcknowledgement',
  data() {
    return {
      schoolID: '',
      SchoolStudentListInt: [],
      SchoolStudentList: [
        {
          prop: 'Index_No',
          label: 'Student NO',
        },
        {
          prop: 'Full_Name',
          label: 'First Name',
        },
        {
          prop: 'Last_name',
          label: 'Last Name',
        },
        {
          prop: 'levelAndClassName',
          label: 'Course/Class',
        },
      ],
      SchoolStudentListFilters: [
        {
          value: '',
          prop: ['Full_Name', 'Index_No', 'ID_Number'],
        },
      ],
      startupText: '',
      pageSize: 200,
      spdSelection: [],
      clickSelection: [],
      selectedStudentID: '',
      hover: false,
      authorizedPickupListInt: [],
      authorizedPickupList: [
        {
          prop: 'AutPickName',
          label: 'Autorized Pickup Person',
        },
        {
          prop: 'AutPickIdentifyNo',
          label: 'Identify No',
        },
        {
          prop: 'AutPickRelationship',
          label: 'Relationship',
        },
        {
          prop: 'AutPickContactNo',
          label: 'Contact No',
        },
      ],
      PickupImageList: [
        {
          prop: 'AutPickImage',
          label: 'Photo',
        },
      ],
      options: {
        penColor: 'black',
      },

      selectedAuthPickup: {},
      pickupInOut: '',
      signIn: false,
      signOut: false,
    }
  },
  async mounted() {
    this.schoolID = Cookies.get('schoolSession')
    await this.getAllStudentBySchoolID()
  },

  methods: {
    async getAllStudentBySchoolID() {
      try {
        this.$vs.loading()
        this.SchoolStudentListInt = []
        const resp = await DataSource.shared.getStudentWithPendingCourse('', '', '', '', '', 'Active', '', '', '', '')
        if (resp.code === '99') {
          this.$notify.error({
            title: 'Error(99)',
            message: 'Please try again',
          })
        } else if (resp.code === '2') {
          this.$notify({
            title: 'No Record',
            message: 'No Record Found',
          })
        } else {
          this.SchoolStudentListInt = resp.Table
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },

    async changeSelection(val) {
      this.spdSelection = val
    },

    async getAuthorizePickupDetail(value) {
      try {
        let result = await this.getStudentAuthorizedPickup(value.Student_ID)
        if (result) {
          if (result.code === '2') {
          } else if (result.code === '99') {
          } else {
            this.$refs.showAuthorizedPickupModal.show()
          }
        }
      } catch (e) {
        this.results = e
      }
    },

    async getStudentAuthorizedPickup(studID) {
      try {
        const resp = await DataSource.shared.getStudentAuthorizedPickup(studID)
        if (resp.code === '99') {
          this.$notify.error({
            title: 'Error(99)',
            message: 'Please try again',
          })
        } else if (resp.code === '2') {
          this.$notify.error({
            title: 'No Record',
            message: 'No Authorized Pickup Record Found',
          })
        } else {
          this.authorizedPickupListInt = resp.Table
          const checkInOutResp = await DataSource.shared.getPickupAcknowledgementDetail(studID)
          if (checkInOutResp.code === '2') {
            //todo: no record for today, let authorized person to sign in
            this.signIn = true
            this.signOut = false
          } else if (checkInOutResp.code === '99') {
            this.signIn = false
            this.signOut = false
            this.$notify.error({
              title: 'Error',
              message: 'Please contact administrator',
            })
          } else {
            //todo: check even or odd number
            if (checkInOutResp.Table.length % 2 == 0) {
              //todo even: signIn
              this.signIn = true
              this.signOut = false
            } else if (checkInOutResp.Table.length % 2 !== 0) {
              //todo odd: signOut
              this.signIn = false
              this.signOut = true
            }
          }
        }
        return resp
      } catch (e) {
        this.results = e
      }
    },

    async getAuthSignature(value, inOutValue) {
      try {
        this.$refs.showSignaturePadModal.show()
        this.selectedAuthPickup = value
        this.pickupInOut = inOutValue
      } catch (e) {
        this.results = e
      }
    },

    async save() {
      try {
        this.$vs.loading()
        const { isEmpty, data } = this.$refs.signaturePad.saveSignature()
        console.log(isEmpty)
        const resp = await DataSource.shared.savePickupAcknowledgement(
          data,
          this.selectedAuthPickup.AutPickStudentID,
          this.selectedAuthPickup.AutPickID,
          this.selectedAuthPickup.AutPickStatus,
          this.pickupInOut,
        )
        if (resp) {
          if (resp.code === '99') {
            this.$notify.error({
              title: 'Error(99)',
              message: 'Failed to save signature, please try again',
            })
          } else if (resp.code === '1') {
            this.$notify({
              title: 'Done',
              message: 'Save successful!',
            })
            this.$refs.showSignaturePadModal.hide()
            this.$refs.showAuthorizedPickupModal.hide()
          }
        }
        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },
    async undo() {
      try {
        this.$refs.signaturePad.undoSignature()
      } catch (e) {
        this.results = e
      }
    },
    async clear() {
      try {
        this.$refs.signaturePad.clearSignature()
      } catch (e) {
        this.results = e
      }
    },
    async onBegin() {
      console.log('=== Begin ===')
      //this.$refs.signaturePad.resizeCanvas();
    },
    async onEnd() {
      console.log('=== End ===')
    },
    async getPickAckReport() {
      try {
        const resp = await DataSource.shared.getPickupAcknowledgementDetail()
      } catch (e) {
        this.results = e
      }
    },
  },
}
</script>

<style scoped>
#signature {
  border: double 3px transparent;
  border-radius: 5px;
  background-image: linear-gradient(white, white), radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-origin: border-box;
  background-clip: content-box, border-box;
}
</style>
